export enum EstadoUser {
  Pendiente = 'Pendiente',
  Validado = 'Validado',
  Bloqueado = 'Bloqueado',
  Inactivo = 'Inactivo',
  Eliminado = 'Eliminado',
  Activo = 'Activo',
}
